module.exports = __webpack_public_path__ + "img/Asset187.4cc14928.svg";